import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import MenuIcon from "../assets/svg/MenuIcon";
import ProfileIcon from "../assets/svg/ProfileIcon";
import RummyIcon from "../assets/svg/RummyIcon";
import TelegramIcon from "../assets/svg/TelegramIcon";
import WalletIcon from "../assets/svg/WalletIcon";
import WhatsappIcon from "../assets/svg/WhatsappIcon";
import BetIcon from "../assets/svg/BetIcon";
import SettingIcon from "../assets/svg/SettingIcon";
import StatementIcon from "../assets/svg/StatementIcon";
import LogoutIcon from "../assets/svg/LogoutIcon";
import GameShowIcon from "../assets/svg/GameShowIcon";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../redux/auth/actions";
import logo from "../assets/svg/logo_new.png";
// import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Fbicon from "../assets/images/head-icon/facebook.png";
import Twitter from "../assets/images/head-icon/twitter.png";
import Telegram from "../assets/images/head-icon/telegram.png";
import Instagram from "../assets/images/head-icon/instagram.png";
import Mobile from "../assets/images/head-icon/mobile.png";
import { AiFillStar } from "react-icons/ai";
import { BsStarHalf } from "react-icons/bs";
import numberWithCommas from "../utils/numbersWithComma";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import EzugiIcon from "../assets/images/betnew1.png";
import EvolutionIcon from "../assets/images/roulette.png";
import SlotsIcon from "../assets/images/jackpot1.png";
import PromotionIcon from "../assets/images/promotenew1.png";
import HomeIcon1 from "../assets/images/homenew1.png";
import SportsIcon1 from "../assets/images/throw.png";
import CasinoIcon1 from "../assets/images/casino-roulette.png";
import Loader from "../assets/images/games-tab/loader-new.gif";
import i18next, { t } from "i18next";
import AffilateIcon from "../assets/images/affiliate-marketing.png";
import { Container, Modal } from "react-bootstrap";
import RealTimeDate from "../views/components/RealTimeDate";
import Aviator from "../assets/images/icons/aviator.png";
import RightArrow from "../assets/images/icons/right-arrow-grey.png";
import LanguageChange from "../views/components/LanguageChange";
import UserIcon from "../assets/images/icons/user.png";
import ArrowIcon from "../assets/images/icons/down-arrow.png";
import AccountIcon from "../assets/images/icons/usericon.png";
import AccIcon from "../assets/images/icons/bankicon.png";
import WithdrawIcon from "../assets/images/icons/money-withdrawal.png";
import MyBetsIcons from "../assets/images/icons/bet.png";
import BonusIcons from "../assets/images/icons/gift.png";
import ReferralIcons from "../assets/images/icons/connection.png";
import DepositIcons from "../assets/images/icons/deposit.png";
import LogoWhite from "../assets/images/logo-white.png";

import HomepageIcon from "../assets/images/icons/home.png";
import CricketIcon from "../assets/images/icons/cricket.png";
import SportsBookIcon from "../assets/images/icons/sportsbook.png";
import LiveBettingIcon from "../assets/images/icons/live-betting.png";
import CasinoIcon from "../assets/images/icons/seven.png";
import LiveCasinoIcon from "../assets/images/icons/live-casino.png";
import PromotionsIcon from "../assets/images/icons/promotions.png";
import AviatorImg from "../assets/images/icons/aviator-img.png";
import FaqIcon from "../assets/images/icons/question.png";
import RightArrowIcon from "../assets/images/icons/right-arrow-white.png";
import MobileIcon from "../assets/images/icons/mobile-phone.png";
import MobileMenu from "./MobileMenu";
import { getNotifications } from "../redux/app/actions";
import { AiOutlineClose } from "react-icons/ai";

const headerPages = [
  "home",
  // "betby?section=cricket",
  // "betby?section=sportsBook",
  // "betby?section=liveBetting",
  "atlas-lobby",
  "aviator",
  "casino?category=gameLobby",
  "casino?category=overview",
];

const HeaderAfterLogin = () => {
  const handleLanguageChange = (value) => {
    i18next.changeLanguage(value.target.value);
    window.location.reload(false);
  };
  const isMobile = window.screen.width <= 767 ? true : false;

  const { user, wallet } = useSelector((state) => state.auth);
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const navigate = useNavigate();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  const handleClose2 = () => setShow2(false);

  const dispatch = useDispatch();
  const { appDetails } = useSelector((state) => state.app);
  const [showToggle, setShowToggle] = useState(true);
  const [isLoader, setShowLoader] = useState(false);
  const [activePage, setActivePage] = useState("");
  const location = useLocation();
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);
  useEffect(() => {
    if (showToggle) {
      document.body.classList.add("header_open");
    } else {
      document.body.classList.remove("header_open");
    }
  }, [showToggle]);

  useEffect(() => {
    setShowToggle(window.screen.width > 991.98);
  }, []);

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth >= 992) {
        setIsScrolled(window.scrollY > 150);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const matchedValue = headerPages.find((f) => {
      if (f?.includes("?")) {
        return (
          location.pathname?.indexOf(f?.split("?")[0]) > -1 &&
          location.search?.indexOf(f?.split("?")[1]) > -1
        );
      } else {
        return location?.pathname.includes(f);
      }
    });
    if (matchedValue) {
      setActivePage(matchedValue);
    }
  }, [location]);

  useEffect(() => {
    loadNotifications();
    return () => {};
  }, []);

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {websiteNotifications.map((notf, idx) => (
              <label style={{ marginRight: "30px" }} key={idx}>
                {notf?.content}
              </label>
            ))}
          </marquee>
          {/* <span onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </span> */}
        </div>
      )) ||
        null}
      <header
        className={isScrolled ? "header aftrlgn secondary" : "header aftrlgn"}
      >
        <div className={isLoader ? "loading_img2" : "loading_img2 d-none"}>
          <img src={Loader} alt="Loader" />
        </div>

        <div className="top-head d-none d-lg-flex">
          <div className="tophead-left">
            <ul>
              <li>
                <a
                  className="panel"
                  href={
                    appDetails?.FACEBOOK != ""
                      ? appDetails?.FACEBOOK
                      : "javascript:void(0)"
                  }
                  target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
                >
                  <img src={Fbicon} />
                  <p>Facebook</p>
                </a>
              </li>
              <li>
                <a
                  className="panel"
                  // href={
                  //   appDetails?.TWITTER != ""
                  //     ? appDetails?.TWITTER
                  //     : "javascript:void(0)"
                  // }
                  // target={appDetails?.TWITTER != "" ? "_blank" : ""}
                >
                  <img src={Twitter} />
                  <p>Twitter</p>
                </a>
              </li>
              <li>
                <a
                  className="panel"
                  href={
                    appDetails?.INSTATGRAM != ""
                      ? appDetails?.INSTATGRAM
                      : "javascript:void(0)"
                  }
                  target={appDetails?.INSTATGRAM != "" ? "_blank" : ""}
                >
                  <img src={Instagram} />
                  <p>Instagram</p>
                </a>
              </li>
              <li>
                <a
                  className="panel"
                  href={
                    appDetails?.TELEGRAM != ""
                      ? appDetails?.TELEGRAM
                      : "javascript:void(0)"
                  }
                  target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                >
                  <img src={Telegram} />
                  <p>Telegram Channel</p>
                </a>
              </li>

              <li>
                <a
                  href={
                    appDetails?.WHATS_APP_URL != ""
                      ? appDetails?.WHATS_APP_URL
                      : "javascript:void(0)"
                  }
                  target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                >
                  <img src={Mobile} />
                  <p>Message Us</p>
                </a>
              </li>
            </ul>
          </div>
          <div className="tophead-right">
            <div className="time-date">
              <RealTimeDate />
            </div>
            {!isMobile && (
              <div className="language ">
                <LanguageChange />
              </div>
            )}
            {/* <div className="language">
            <LanguageChange />
          </div> */}
          </div>
        </div>

        <Modal
          show={show1}
          onHide={handleClose1}
          backdrop="static"
          keyboard={false}
          className="app-modal"
        >
          <Modal.Body closeButton>
            <div className="app-installed">
              <div className="app-left-part">
                <Button variant="secondary" onClick={handleClose1}>
                  X
                </Button>
                <div className="app-body">
                  <a className="app-name">
                    <h5>Betheroz</h5>
                    <div className="app-rate">
                      <AiFillStar />
                      <AiFillStar />
                      <AiFillStar />
                      <AiFillStar />
                      <BsStarHalf />
                    </div>
                    <a
                      href="./images/0TtatjwLdZwgvIkSmZxS.apk"
                      download="0TtatjwLdZwgvIkSmZxS.apk"
                    >
                      Download the app
                    </a>
                  </a>
                </div>
              </div>

              <div className="app-install-btn">
                <a
                  href="./images/0TtatjwLdZwgvIkSmZxS.apk"
                  download="0TtatjwLdZwgvIkSmZxS.apk"
                >
                  <button type="button" className="installBtn">
                    INSTALL
                  </button>
                </a>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <div className="d-flex justify-content-between align-items-center nav-head">
          <div className="d-flex align-items-center">
            <div className="logo">
              <a href="/">
                {appDetails?.LOGO_URL && (
                  <>
                    <img
                      src={appDetails?.LOGO_URL}
                      alt="Logo"
                      className="logo-blk"
                    />
                    <img src={LogoWhite} alt="Logo" className="logo-wt" />
                  </>
                )}
              </a>
            </div>
            <Navbar expand="lg">
              <Container>
                <Navbar.Collapse id="basic-navbar-nav">
                  <Nav className="me-auto">
                    <Nav.Link
                      href={"/atlas-lobby"}
                      className={activePage == "atlas-lobby" ? "active" : ""}
                    >
                      Cricket
                    </Nav.Link>
                    <Nav.Link
                      href="/atlas-lobby"
                      className={activePage == "atlas-lobby" ? "active" : ""}
                    >
                      SportsBook
                    </Nav.Link>
                    <Nav.Link
                      href="/atlas-lobby"
                      className={activePage == "atlas-lobby" ? "active" : ""}
                    >
                      Live Betting
                    </Nav.Link>
                    <Nav.Link
                      onClick={() =>
                        navigate("/casino?category=gameLobby", {
                          state: { activeCategory: "Game Lobby" },
                        })
                      }
                      className={
                        activePage == "casino?category=gameLobby"
                          ? "active"
                          : ""
                      }
                    >
                      Casino
                    </Nav.Link>

                    <Nav.Link
                      onClick={() =>
                        navigate("/casino?category=overview", {
                          state: { activeCategory: "Overview" },
                        })
                      }
                      className={
                        activePage == "casino?category=overview" ? "active" : ""
                      }
                    >
                      Live Casino
                    </Nav.Link>
                    <Nav.Link
                      onClick={() =>
                        navigate("/casino/aggapspribe-aviator", {
                          state: { activeCategory: "Aviator" },
                        })
                      }
                      className={
                        activePage == "casino/aggapspribe-aviator" ? "active" : ""
                      }
                    >
                      <img src={Aviator} alt="Aviator" />
                    </Nav.Link>
                    <Nav.Link
                      onClick={() =>
                        navigate("/promotion", {
                          state: { activeCategory: "promotion" },
                        })
                      }
                    >
                      Promotion
                    </Nav.Link>

                    <Nav.Link className="menu__more d-none">
                      More
                      <img src={RightArrow} alt="Aviator" />
                      <div className="othermenu">
                        <ul>
                          <li
                            onClick={() => navigate("/casino/aggapspribe-aviator")}
                          >
                            <a href="/casino/aggapspribe-aviator">
                              <p>
                                <img src={Aviator} alt="Aviator" />
                              </p>
                              <img src={RightArrow} alt="Aviator" />
                            </a>
                          </li>
                          <li onClick={() => navigate("/casino")}>
                            <a href="javascript:void(0)">
                              <p>PROMOTIONS</p>
                              <img src={RightArrow} alt="Aviator" />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </Nav.Link>
                  </Nav>
                </Navbar.Collapse>
              </Container>
            </Navbar>
            {/* <Button variant="primary menu-btn" onClick={handleShow2}>
            <MenuIcon />
          </Button> */}
          </div>
          <div className="headerRight">
            <div className="UserDepositSection ">
              <div className="user-drop d-md-flex d-none gap-2">
                <div className="user-drop--top">
                  <img src={UserIcon} alt="UserIcon" />
                  <p>{user?.mstruserid}</p>
                  <img src={ArrowIcon} alt="ArrowIcon" className="arrow" />
                </div>
                <div className="user-drop--wrp">
                  <div className="user-drop--content">
                    <div class="top">
                      <div class="left">
                        <p class="user__name">{user?.mstruserid}</p>{" "}
                      </div>{" "}
                      <div class="right">
                        <button
                          class="button button-white mr-0"
                          onClick={() => dispatch(logoutUser())}
                        >
                          <p class="txt">Logout</p>
                        </button>
                      </div>
                    </div>
                    <div class="balance">
                      <div class="item">
                        <p class="name">Main Balance</p>{" "}
                        <p class="balance__amount">
                          {numberWithCommas(wallet?.balance || 0)}
                        </p>
                      </div>{" "}
                      <div class="item">
                        <p class="name">Bonus Balance</p>{" "}
                        <p class="balance__amount">
                          {numberWithCommas(wallet?.bonus || 0)}
                        </p>
                      </div>
                    </div>
                    <div class="info">
                      <div class="elements">
                        <a href="/profile" class="elements-link">
                          <img src={AccountIcon} alt="" />
                          <p class="txt">Account</p>
                        </a>
                      </div>
                      <div class="elements">
                        <a href="/withdraw" class="elements-link">
                          <img src={WithdrawIcon} alt="" />
                          <p class="txt">Withdraw</p>
                        </a>
                      </div>
                      <div class="elements">
                        <a href="/cashier" class="elements-link">
                          <img src={AccIcon} alt="" />{" "}
                          <p class="txt">Account Statement</p>
                        </a>
                      </div>
                      <div class="elements">
                        <a href="/mybets" class="elements-link">
                          <img src={MyBetsIcons} alt="" />{" "}
                          <p class="txt">My Bets</p>
                        </a>
                      </div>
                      <div class="elements">
                        <a href="/bonus" class="elements-link">
                          <img src={BonusIcons} alt="" />{" "}
                          <p class="txt">Bonus</p>
                        </a>
                      </div>{" "}
                      <div class="elements">
                        <a href="/referral" class="elements-link">
                          <img src={ReferralIcons} alt="" />{" "}
                          <p class="txt">Referral</p>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <a href="/gatewaylist" className="user-deposit">
                <div className="user-deposit__item">
                  <p className="user-deposit__item-balance">
                    {numberWithCommas(wallet?.balance || 0)}
                  </p>
                </div>
                <div className="user-deposit__item">
                  <p class="user-deposit__item-text">Deposit</p>
                </div>
              </a>
            </div>

            <Button
              variant="primary menu-btn"
              onClick={handleShow}
              className="d-md-none d-flex"
            >
              <img src={UserIcon} alt="UserIcon" />
              <p>{user?.mstruserid}</p>
            </Button>
          </div>
        </div>

        <div className="container d-none">
          <div className="row">
            <div className="col-12">
              <div className="d-flex justify-content-between">
                <div className="d-flex align-items-center">
                  <div className="logo">
                    <a href="/home">
                      {appDetails?.LOGO_URL && (
                        <img src={appDetails?.LOGO_URL} />
                      )}
                    </a>
                  </div>
                  <Navbar expand="">
                    <Navbar.Toggle
                      aria-controls="basic-navbar-nav"
                      onClick={() => setShowToggle((s) => !s)}
                    />
                    <Navbar.Collapse id="basic-navbar-nav">
                      <Nav>
                        <Nav.Link href="/home" className="logoImg">
                          {appDetails?.LOGO_URL && (
                            <img src={appDetails?.LOGO_URL} />
                          )}
                        </Nav.Link>
                        <Nav.Link href="/home">
                          {/* <HomeIcon />  */}
                          <img src={HomeIcon1} />
                          Home
                        </Nav.Link>
                        <Nav.Link href="/atlas-lobby">
                          {/* <SportsIcon />  */}
                          <img src={SportsIcon1} />
                          Sportsbook
                        </Nav.Link>
                        <Nav.Link href="/casino">
                          {/*<GamesIcon />*/}
                          <img src={CasinoIcon1} />
                          Casino
                        </Nav.Link>
                        <Nav.Link href="/casino/aggapspribe-aviator">
                          <img src={SlotsIcon} />
                          Aviator
                        </Nav.Link>
                        <Nav.Link href="/casino/aggapezugi-ezugi-lobby">
                          <img src={EzugiIcon} />
                          Ezugi
                        </Nav.Link>
                        <Nav.Link href="/casino/evolution">
                          <img src={EvolutionIcon} />
                          Evolution
                        </Nav.Link>

                        <Nav.Link href="https://portal.sportsmanager.app/">
                          <img src={PromotionIcon} />
                          Promotions
                        </Nav.Link>

                        <a href="" className="affiliate-link">
                          <img src={AffilateIcon} />
                          <span>
                            Affilate
                            <p></p>
                          </span>
                        </a>

                        {/* <Nav.Link href="/cashier">
                        <CashierIcon /> Account statement
                      </Nav.Link> */}
                      </Nav>
                    </Navbar.Collapse>
                  </Navbar>
                </div>
                <div className="headerRight">
                  <div className="funds">
                    <ul>
                      {/* <li>
                      <a href="#">
                        Exch Bal:{" "}
                        <span>{numberWithCommas(wallet?.sports || 0)}</span>
                      </a>
                    </li> */}
                      <li
                        className="d-md-none"
                        onClick={() => {
                          navigate("/gatewaylist");
                        }}
                      >
                        <Button variant="primary deposit-btn w-100">
                          DEPOSIT
                        </Button>
                      </li>
                      <li>
                        {/* <a href="#">
                        <span className="d-none d-md-block pe-md-2">
                          Balance:
                        </span>{" "}
                        <span>
                          {numberWithCommas(wallet?.balance || 0)}
                        </span>
                      </a> */}
                        <DropdownButton id="" title="Balance">
                          <Dropdown.Item href="#/action-1">
                            <div className="currency-head">
                              <div className="active currency-section">
                                <div className="currency-sign">
                                  <span>$</span>
                                </div>
                                <div className="currency-name">
                                  <span>MAIN ACCOUNT</span>
                                  <span>
                                    {numberWithCommas(wallet?.balance || 0)}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </Dropdown.Item>
                          {/* <Dropdown.Item href="#/action-2">
                          <div className="currency-head">
                            <div className="currency-section">
                              <div className="currency-sign">
                                <span>$</span>
                              </div>
                              <div className="currency-name">
                                <span>...</span>
                                <span>0.01</span>
                              </div>
                            </div>
                          </div>
                        </Dropdown.Item> */}
                        </DropdownButton>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <MobileMenu />

        <Offcanvas
          show={show}
          onHide={handleClose}
          placement={"end"}
          className="MobileView"
        >
          <Offcanvas.Header closeButton="closeButton" closeVariant="white">
            <Offcanvas.Title>
              <div className="d-flex">
                <div className="profile-img">
                  <ProfileIcon />
                </div>
                <div className="user-info">
                  <span>{user?.mstruserid}</span>
                  <p>{user?.mobileno}</p>
                </div>
              </div>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="row BalanceBox">
              <div className="col-6">
                <div className="balance mb-3">Main Balance</div>
              </div>
              <div className="col-6">
                <div className="balance-amount mb-3">
                  {numberWithCommas(wallet?.balance || 0)}
                </div>
              </div>
              <div className="col-6">
                <div className="balance mb-3">Bonus Balance</div>
              </div>
              <div className="col-6">
                <div className="balance-amount mb-3">
                  {numberWithCommas(wallet?.bonus || 0)}
                </div>
              </div>
            </div>
            <ul className="menu-items">
              <li>
                <a href="/gatewaylist">
                  <img src={DepositIcons} alt="" />
                  <span>Deposit</span>
                </a>
              </li>{" "}
              <li>
                <a href="/withdraw">
                  <img src={WithdrawIcon} alt="" />
                  <span>Withdraw</span>
                </a>
              </li>
              <li>
                <a href="/profile">
                  <img src={AccountIcon} alt="" />
                  <span>Profile</span>
                </a>
              </li>
              <li>
                <a href="/mybets">
                  <img src={MyBetsIcons} alt="" />
                  <span>My Bets</span>
                </a>
              </li>
              <li>
                <a href="/cashier">
                  <img src={AccIcon} alt="" />
                  <span>Account Statement</span>
                </a>
              </li>
              <li>
                <a href="/referral">
                  <img src={ReferralIcons} alt="" />
                  <span>Referral</span>
                </a>
              </li>
              <li>
                <a href="/bonus">
                  <img src={BonusIcons} alt="" />
                  <span>Bonus</span>
                </a>
              </li>
              <li onClick={() => dispatch(logoutUser())} className="Signout">
                <a href="/">
                  {/* <img src={SignOutIcon} alt="" /> */}
                  <span>Sign Out</span>
                </a>
              </li>
            </ul>
            {/* <ul className="social_links">
            <li>
              <a href="" target="_blank">
                <TelegramIcon />
              </a>
            </li>

            <li>
              <a
                href={
                  appDetails?.WHATS_APP_URL != ""
                    ? appDetails?.WHATS_APP_URL
                    : "javascript:void(0)"
                }
                target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
              >
                <span className="notification-count">2</span>
                <WhatsappIcon />
              </a>
            </li>
          </ul> */}
          </Offcanvas.Body>
        </Offcanvas>

        <Offcanvas show={show2} onHide={handleClose2} placement={"end"}>
          <Offcanvas.Header
            closeButton="closeButton"
            closeVariant="white"
          ></Offcanvas.Header>
          <Offcanvas.Body>
            <div className="row">
              <div className="col-6">
                <div className="balance mb-3">Main Balance</div>
              </div>
              <div className="col-6">
                <div className="balance-amount mb-3">
                  {numberWithCommas(wallet?.balance || 0)}
                </div>
              </div>
              <div
                className="col-6"
                onClick={() => {
                  navigate("/withdraw");
                }}
              >
                <Button variant="outline-secondary w-100">Withdraw</Button>
              </div>
              <div
                className="col-6"
                onClick={() => {
                  navigate("/gatewaylist");
                }}
              >
                <Button variant="primary w-100">Deposit</Button>
              </div>
            </div>
            <ul className="menu-items">
              <li>
                <a href="/profile">
                  <ProfileIcon />
                  <span>Profile</span>
                </a>
              </li>
              <li>
                <a href="/mybets">
                  <BetIcon />
                  <span>My Bets</span>
                </a>
              </li>
              <li>
                <a href="/cashier">
                  <StatementIcon />
                  <span>Account Statement</span>
                </a>
              </li>
              {/* <li>
              <a href="#">
                <SettingIcon />
                <span>Transfer Funds ( For Excahnge)</span>
              </a>
            </li> */}
              {/* <li>
              <a href="/settings">
                <SettingIcon />
                <span>Settings</span>
              </a>
            </li> */}
              <li onClick={() => dispatch(logoutUser())}>
                <a href="/">
                  <LogoutIcon />
                  <span>Sign Out</span>
                </a>
              </li>
            </ul>
            <ul className="social_links">
              <li>
                <a href="" target="_blank">
                  <TelegramIcon />
                </a>
              </li>

              <li>
                <a
                  href={
                    appDetails?.WHATS_APP_URL != ""
                      ? appDetails?.WHATS_APP_URL
                      : "javascript:void(0)"
                  }
                  target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                >
                  <span className="notification-count">2</span>
                  <WhatsappIcon />
                </a>
              </li>
            </ul>
          </Offcanvas.Body>
        </Offcanvas>
      </header>
    </>
  );
};

export default HeaderAfterLogin;
